(() => {
  const hasExistingFaqSchema = () => {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      const text = script.textContent || '';
      if (text.includes('FAQPage')) {
        return true;
      }
      try {
        const parsed = JSON.parse(text);
        if (containsFaqPage(parsed)) {
          return true;
        }
      } catch (e) {
        // Ignore invalid JSON-LD blocks.
      }
    }
    return false;
  };

  const containsFaqPage = (value) => {
    if (!value) return false;
    if (Array.isArray(value)) {
      return value.some(containsFaqPage);
    }
    if (typeof value === 'object') {
      const type = value['@type'];
      if (type === 'FAQPage' || (Array.isArray(type) && type.includes('FAQPage'))) {
        return true;
      }
      return Object.values(value).some(containsFaqPage);
    }
    if (typeof value === 'string') {
      return value.includes('FAQPage');
    }
    return false;
  };

  const buildFaqSchema = () => {
    const detailsNodes = Array.from(document.querySelectorAll('.ip-faq details'));
    if (detailsNodes.length === 0) return null;

    const mainEntity = [];

    detailsNodes.forEach((details) => {
      const summary = details.querySelector('summary');
      const question = summary ? summary.textContent.trim() : '';
      if (!question) return;

      const answerNodes = details.querySelectorAll('p, li');
      const answerText = Array.from(answerNodes)
        .map((node) => node.textContent.trim())
        .filter(Boolean)
        .join(' ');

      if (!answerText) return;

      mainEntity.push({
        '@type': 'Question',
        'name': question,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': answerText
        }
      });
    });

    if (mainEntity.length === 0) return null;

    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      'mainEntity': mainEntity
    };
  };

  const injectSchema = (schema) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  };

  const init = () => {
    if (hasExistingFaqSchema()) return;
    const schema = buildFaqSchema();
    if (!schema) return;
    injectSchema(schema);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
